import { call, put, takeLatest } from "redux-saga/effects";
import request from "utils/request";
import { creatorSubscriptionActions } from "./index";
import { showToast } from "components/ToastContainer/index";

function* fetchCreatorSubscriptions(action) {
  try {
    const { creator_user_id } = action.payload;

    const response = yield call(
      request,
      `/api/creator_subscriptions/${creator_user_id}`,
      {
        method: "GET"
      }
    );

    yield put(
      creatorSubscriptionActions.fetchCreatorSubscriptionsSuccess(response)
    );
  } catch (error) {
    yield put(
      creatorSubscriptionActions.fetchCreatorSubscriptionsFailure(error.message)
    );
  }
}

function* fetchCreatorSubscriptionDetails(action) {
  try {
    const { subscriptionId, ...queryParams } = action.payload;

    const queryString = Object.keys(queryParams)
      .map((key) => `${key}=${encodeURIComponent(queryParams[key])}`)
      .join("&");

    const response = yield call(
      request,
      `/api/creator_subscriptions/details/${subscriptionId}?${queryString}`,
      {
        method: "GET"
      }
    );

    yield put(
      creatorSubscriptionActions.fetchCreatorSubscriptionDetailsSuccess(
        response
      )
    );
  } catch (error) {
    yield put(
      creatorSubscriptionActions.fetchCreatorSubscriptionDetailsFailure(
        error.message
      )
    );
  }
}

function* changePlan(action) {
  try {
    const { creator_user_id, plan, deactivation_reason, subscriptionId } =
      action.payload;

    const response = yield call(
      request,
      `/api/creator_subscriptions/${creator_user_id}/change-plan`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          plan,
          deactivation_reason
        })
      }
    );

    yield put(
      creatorSubscriptionActions.changePlanSuccess({
        subscriptionId: response.subscription.id
      })
    );

    showToast(response?.message, "success");

    // Refresh the details page with the new subscription
    yield put(
      creatorSubscriptionActions.fetchCreatorSubscriptionDetailsRequest({
        subscriptionId: response?.subscription?.id,
        page: 1,
        limit: 10
      })
    );
  } catch (error) {
    const message = error?.message || "Failed to change plan.";
    yield put(creatorSubscriptionActions.changePlanFailure(message));
    showToast(message, "error");
  }
}
export function* creatorSubscriptionSaga() {
  yield takeLatest(
    creatorSubscriptionActions.fetchCreatorSubscriptionsRequest.type,
    fetchCreatorSubscriptions
  );
  yield takeLatest(
    creatorSubscriptionActions.fetchCreatorSubscriptionDetailsRequest.type,
    fetchCreatorSubscriptionDetails
  );
  yield takeLatest(
    creatorSubscriptionActions.changePlanRequest.type,
    changePlan
  );
}
